import React from "react";

import * as TimeTracking from "~/TimeTracking";
import { EuiCallOut } from "@equipmentshare/ds2";
import { RevisionStatusWarningProps } from "../RevisionStatusWarningProps";

export const RevisionStatusWarningFlyout = ({driverId, startDate}: RevisionStatusWarningProps) => {
  const revisionStatus = TimeTracking.RevisionStatus.Data.useWhenAvailable(driverId, startDate);

  return revisionStatus?.revisionStatusMessage ? (
          <EuiCallOut
            iconType="alert"
            color="warning"
            size="s"
            title={<span data-testid="revision-status-warning-message">{revisionStatus.revisionStatusMessage}</span>}
            style={{ marginLeft: '-25px',  marginRight: '-25px', padding: '18px' }}
          >
          </EuiCallOut>
    ) : null;
};
